var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "CardBase",
        [
          _c(
            "MacroSubHeader",
            { attrs: { title: "Popups", icon: "el-icon-news" } },
            [
              _c(
                "template",
                { slot: "actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.openModal }
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus" }),
                      _vm._v(
                        "\n                    Adicionar\n                "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            2
          ),
          _vm._v(" "),
          _c("CardBase", [_c("PopupList", { ref: "popupList" })], 1)
        ],
        1
      ),
      _vm._v(" "),
      _c("PopupCreateModal", {
        ref: "popupCreateModal",
        on: { created: _vm.handleDispatch }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-749efc02", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-749efc02","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_internal/configuracoes/popup/Index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-749efc02","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_internal/configuracoes/popup/Index.vue
// module chunks = 2